import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { articlesAPI } from '../utils/api';
import { ArticleCard } from '../components/ArticleCard';
import { Search } from 'lucide-react';

export const SearchPage = () => {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchResults = async () => {
      if (!query) {
        setLoading(false);
        return;
      }

      try {
        const response = await articlesAPI.search(query);
        setResults(response.data);
      } catch (error) {
        console.error('Search failed:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchResults();
  }, [query]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-brand-red mx-auto mb-4"></div>
          <p className="text-gray-600 font-inter">Searching...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" data-testid="search-page">
      <div className="bg-brand-green text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-4 mb-4">
            <Search className="w-8 h-8" />
            <h1 className="text-4xl md:text-5xl font-playfair font-bold">Search Results</h1>
          </div>
          <p className="text-xl text-gray-200" data-testid="search-query">
            Showing results for: <span className="font-bold">"{query}"</span>
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {results.length > 0 ? (
          <>
            <p className="text-gray-600 font-inter mb-8" data-testid="results-count">
              Found {results.length} article{results.length !== 1 ? 's' : ''}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="search-results">
              {results.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
          </>
        ) : (
          <div className="text-center py-16" data-testid="no-results">
            <p className="text-gray-600 font-inter text-lg mb-4">
              No articles found matching your search.
            </p>
            <Link to="/" className="text-brand-red font-bold hover:underline">
              Return to Homepage
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};